<div class="mwp-modal">
    <div class="header">
        <mwp-text-translate text={{title}} [jsonKey]="titleJsonKey" />
    </div>
    <div class="body">
        <div class="message-container mb-3">
            <div class="mb-2">
                <mwp-text-translate text="Please enter your email address below to receive your {{ documentType }}" jsonKey="emailBenefitSummary2" />
            </div>
            <div class="mb-2">
                <mwp-text-translate text="ATTENTION" jsonKey="ATTENTION" />
            </div>
            <div class="mb-2">
                <mwp-text-translate text={{warningText}} [jsonKey]="warningTextJsonKey" />
            </div>
        </div>
        <form [formGroup]="inputForm">
            <div class="mb-3">
                <mwp-input [form]="inputForm" labelName="Email" nameForControl="emailInput" />
            </div>
        </form>
    </div>
    <div class="footer d-inline-flex justify-content-end w-100">
        <button class="mwp-button-secondary me-3" (click)="close()">
            <mwp-text-translate text="CANCEL" jsonKey="cancel" />
        </button>
        <button class="mwp-button" [disabled]="inputForm.invalid" (click)="buttonClicked()">
            <mwp-text-translate text={{buttonText}} [jsonKey]="buttonTextJsonKey" />
        </button>
    </div>
</div>